import { SafeAreaRefType } from 'components/ui/SafeArea'
import { useRef } from 'preact/hooks'

export default function useRefs() {
  const prevActivePageIndexRef = useRef<number>(0)
  const safeAreaRef = useRef<SafeAreaRefType>(null)
  const brandingRef = useRef<HTMLDivElement>(null)

  return {
    prevActivePageIndexRef,
    safeAreaRef,
    brandingRef,
  }
}
